// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2fEa2","items":"Footer_items__7e41w"};